import {
  ChartDescription,
  ChartDescriptionFeature,
  ChartDescriptionFeaturesGroup,
  ChartDescriptionFilter,
} from 'src/app/core/entities/chart-description';
import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';

import { ChartLabel } from 'src/app/core/entities/chart-dataset';
import { ChartService } from 'src/app/core/services/chart.service';
import { Patient } from 'src/app/core/entities/patient.entity';

@Component({
  selector: 'app-chart-description',
  templateUrl: './chart-description.component.html',
  styleUrls: ['./chart-description.component.css'],
})
export class ChartDescriptionComponent implements OnInit {
  @Input() public startDate: Date | string = new Date();
  @Input() public endDate: Date | string = new Date();
  @Input() public patient: Patient = new Patient();
  @Input() public xLabels: ChartLabel[] = [];
  @Input() public chartDescription: ChartDescription = {
    evaluationCode: '',
    evaluationLabel: '',
    measuringPointsTotal: 0,
    featuresGroups: [],
  };

  constructor(public chartService: ChartService) {}

  ngOnInit(): void {}

  getResumeNbValues(resume: any): number {
    const keys = resume.filterValue;
    let indexes = [];

    this.chartDescription.featuresGroups.forEach((featuresGroup) => {
      featuresGroup.features.forEach((feature) => {
        indexes = [
          ...new Set(
            indexes.concat(
              [...feature.data.keys()].filter(
                (i) =>
                  feature.data[i].filteredBy != null &&
                  feature.data[i].filteredBy.some((item) => keys.includes(item))
              )
            )
          ),
        ];
      });
    });

    return indexes.length;
  }

  hasFilteredFeatures(filter: ChartDescriptionFilter): boolean {
    return (
      _.cloneDeep(this.chartDescription.featuresGroups)
        .reduce((origin, value) => {
          origin.features = origin.features.concat(value.features);
          return origin;
        })
        .features.filter(
          (feature) =>
            !feature.hidden &&
            0 <
              [...feature.data.keys()].filter(
                (i) =>
                  feature.data[i].filteredBy != null &&
                  feature.data[i].filteredBy.some(
                    (item) => item === filter.value
                  )
              ).length
        ).length > 0
    );
  }

  hasFeaturesGroups(): boolean {
    return 0 < this.chartDescription.featuresGroups.length;
  }

  hasFeaturesInGroup(featuresGroup: ChartDescriptionFeaturesGroup): boolean {
    return (
      featuresGroup.features.filter(
        (feature) =>
          0 <
          [...feature.data.keys()].filter((i) => feature.data[i].value != null)
            .length
      ).length > 0
    );
  }

  getFeaturesByFilter(
    featureGroup: ChartDescriptionFeaturesGroup,
    filter: ChartDescriptionFilter
  ): ChartDescriptionFeature[] {
    return featureGroup.features.filter(
      (feature) =>
        !feature.hidden &&
        0 <
          [...feature.data.keys()].filter(
            (i) =>
              feature.data[i].filteredBy != null &&
              feature.data[i].filteredBy.some((item) => item === filter.value)
          ).length
    );
  }

  getShownFeatures(
    featuresGroup: ChartDescriptionFeaturesGroup,
    filter: ChartDescriptionFilter = null
  ): ChartDescriptionFeature[] {
    return featuresGroup.features.filter((feature) => {
      // remove to show all texts
      // if (feature.hidden) {
      //   return false;
      // }

      if (filter) {
        return (
          0 <
          [...feature.data.keys()].filter(
            (i) =>
              feature.data[i].filteredBy != null &&
              feature.data[i].filteredBy.some((item) => item === filter.value)
          ).length
        );
      }

      return true;
    });
  }

  getProgressionValueStartDate(
    feature: ChartDescriptionFeature,
    filter: ChartDescriptionFilter = null
  ): string {
    const data =
      filter != null
        ? this.getFilteredFeatureData(feature, filter)
        : feature.data;
    const firstItem = data.find((item) => item.value != null);
    return firstItem !== undefined ? firstItem.value : '';
  }

  getProgressionValueEndDate(
    feature: ChartDescriptionFeature,
    filter: ChartDescriptionFilter = null
  ): string {
    const data =
      filter != null
        ? this.getFilteredFeatureData(feature, filter)
        : feature.data;
    const keys = [...data.keys()].filter((i) => data[i].value != null);
    return keys.length > 0 ? data[keys[keys.length - 1]].value : '';
  }

  getFilteredFeatureData(
    feature: ChartDescriptionFeature,
    filter: ChartDescriptionFilter
  ): any[] {
    return feature.data.filter(
      (i) =>
        i.filteredBy != null &&
        i.filteredBy.some((item) => item === filter.value)
    );
  }
}
